<template>
  <button
    class="native-button"
    :class="[`native-button-${type}`, { 'native-button-small': size === 'small' }]"
    :type="nativeType"
    :disabled="disabled || loading"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    type?: string;
    size?: string;
    disabled?: boolean;
    loading?: boolean;
    nativeType?: "button" | "submit" | "reset";
  }>(),
  { type: "default", size: "default", nativeType: "button" },
);
</script>

<style scoped>
.native-button {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px 14px;
  border: 1px solid #d5dbe3;
  border-radius: 5px;
  background: #fff;
  color: #334155;
  font: inherit;
  cursor: pointer;
}

.native-button-primary {
  border-color: #287d6a;
  background: #287d6a;
  color: #fff;
}

.native-button-success {
  border-color: #23835d;
  background: #23835d;
  color: #fff;
}

.native-button-danger {
  border-color: #d14343;
  background: #fff;
  color: #c53030;
}

.native-button-small {
  min-height: 28px;
  padding: 4px 9px;
  font-size: 0.875rem;
}

.native-button:hover:not(:disabled) {
  filter: brightness(0.96);
}

.native-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
</style>
